import React, { Component } from 'react';
import AppStore from '../../stores/app-store.js'
import TextField from 'material-ui/TextField';
import { nomeJogadorActions } from '../../actions/app-actions.js'
import './NovoNome.css';


class NovoNome extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nomeJogador: AppStore.getNomeJogador(),
            legendas: AppStore.legendas,
        }
        this.onChangeNomeJogador = this.onChangeNomeJogador.bind(this);
        this.onChangeLingua = this.onChangeLingua.bind(this);
    }

    componentWillMount() {
        AppStore.addChangeNomeJogadorListener(this.onChangeNomeJogador);
        AppStore.addChangeLinguaListener(this.onChangeLingua);
    }

    componentWillUnmount() {
        AppStore.removeChangeNomeJogadorListener(this.onChangeNomeJogador);
        AppStore.removeChangeLinguaListener(this.onChangeLingua);
    }

    handleInputChange = (event) => {
        this.setState({
            nomeJogador: event.target.value,
        });
        nomeJogadorActions.definirNome(event.target.value);
    };

    onChangeNomeJogador() {
        this.setState({
            nomeJogador: AppStore.getNomeJogador(),
        });
    }

    onChangeLingua() {
        this.setState({
            legendas: AppStore.legendas,
        })
    }

    render() {
        if (this.props.rendered === true) {
            return (
                <TextField
                    style={{ maxWidth: '90%', fontFamily: 'OpenSans', color: 'white' }}
                    textareaStyle={{ color: 'white' }}
                    inputStyle={{ color: 'white' }}
                    hintStyle={{ color: 'white' }}
                    hintText={this.state.nomeJogador}
                    floatingLabelText={this.state.legendas.mudarNomeJogador}
                    floatingLabelStyle={{ color: 'white' }}
                    multiLine={false}
                    rows={1}
                    rowsMax={1}
                    value={this.state.nomeJogador}
                    onChange={this.handleInputChange}
                />
            );
        } else {
            return (
                <h3>{this.state.legendas.clicarNomeJogador}</h3>
            );
        }
    }
}

export default NovoNome;


// WEBPACK FOOTER //
// ./src/componentes/novonome/NovoNome.js